import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.48 4.89h5.19c.23.93 1.06 1.63 2.06 1.63s1.84-.7 2.06-1.63h5.44c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H10.8a2.132 2.132 0 0 0-2.06-1.63c-1 0-1.84.7-2.06 1.63h-5.2c-.28 0-.5.22-.5.5s.22.5.5.5zm7.25-1.63a1.129 1.129 0 1 1 .002 2.262A1.129 1.129 0 0 1 8.73 3.26zm7.79 5.27h-1.61c-.23-.93-1.06-1.63-2.06-1.63s-1.84.7-2.06 1.63H1.48c-.28 0-.5.22-.5.5s.22.5.5.5h9.31c.23.93 1.06 1.63 2.06 1.63s1.84-.7 2.06-1.63h1.61c.28 0 .5-.22.5-.5s-.22-.5-.5-.5zm-3.67 1.63c-.62 0-1.13-.51-1.13-1.13 0-.62.51-1.13 1.13-1.13s1.13.51 1.13 1.13c0 .62-.51 1.13-1.13 1.13zm3.38 3.01H7.86c-.23-.93-1.06-1.63-2.06-1.63s-1.84.7-2.06 1.63H1.48c-.28 0-.5.22-.5.5s.22.5.5.5h2.26c.22.93 1.06 1.63 2.06 1.63s1.84-.7 2.06-1.63h8.37c.28 0 .5-.22.5-.5s-.22-.5-.5-.5zM5.8 14.8c-.62 0-1.13-.51-1.13-1.13s.51-1.13 1.13-1.13 1.13.51 1.13 1.13-.51 1.13-1.13 1.13z"
    }, null, -1)
  ])))
}
export default { render };